import React, { useEffect } from "react";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import { Form, Input } from "semantic-ui-react";
interface ModAuthenProps {
  open?: boolean;
  titleColor?: string;
  titleName?: string;
  onDeny?: () => void;
  error?: Record<string, any> | string;
  onApprove?: (data: { password: string; username: string }) => void;
  headerColor?: string;
  backgroundColor?: string;
  loading?: boolean;
  style?: Record<string, any>;
  approveButtonLoading?: boolean;
  basic?: boolean;
  isRequire?: boolean;
  approveButtonStyle?: Record<string, any>;
  denyButtonStyle?: Record<string, any>;
}

const DEFAULT_PROPS = {
  open: false,
  titleName: "กรุณายืนยัน Username และ Password อีกครั้ง",
  onDeny: () => {},
  error: null,
  onApprove: () => {},
  loading: false,
  style: {},
  basic: true,
  isRequire: false,
};

const ModAuthen = React.forwardRef<any, ModAuthenProps>((propsParam, ref) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value]) => value !== undefined)),
  };
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(null);

  useEffect(() => {
    if (props.error) {
      setError(props.error);
    }
  }, [props.error]);

  useEffect(() => {
    if (props.open) {
      setUsername("");
      setPassword("");
      setError(null);
    }
  }, [props.open]);

  React.useImperativeHandle(ref, () => ({
    clear: () => {
      setUsername("");
      setPassword("");
      setError(null);
    },
  }));

  return (
    <ModConfirm
      titleColor={props.titleColor}
      backgroundColor={props.backgroundColor}
      openModal={props.open}
      titleName={props.titleName}
      onDeny={props.onDeny}
      onCloseWithDimmerClick={props.onCloseWithDimmerClick}
      onApprove={() => props.onApprove({ username, password })}
      loading={props.loading}
      approveButtonText={props.approveButtonText}
      approveButtonLoading={props.approveButtonLoading}
      denyButtonText={props.denyButtonText}
      modalStyle={props.style}
      basic={props.basic}
      customGridGroup={props.customGridGroup}
      customGridButton={props.customGridButton}
      denyButtonColor={props.denyButtonColor}
      approveButtonColor={props.approveButtonColor}
      approveButtonStyle={props.approveButtonStyle}
      denyButtonStyle={props.denyButtonStyle}
      content={
        <Form
          error={error ? true : false}
          onSubmit={props.approveButtonText}
          style={{ margin: "-0.25rem 0 -0.25rem" }}
        >
          <ErrorMessage error={error} />
          <Form.Field
            error={error ? true : false}
            style={props.inline ? { display: "flex", alignItems: "center" } : {}}
          >
            <div
              style={{
                display: "flex",
                fontSize: "13px",
                fontWeight: "bold",
                ...(props.inline ? { flex: 2 } : {}),
              }}
            >
              <label>Username</label>
              {props.isRequire && <div style={{ color: "red" }}>*</div>}
            </div>
            <Input
              placeholder="Username"
              value={username}
              fluid
              style={props.inline ? { flex: 4 } : {}}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Field>
          <Form.Field
            error={error ? true : false}
            style={props.inline ? { display: "flex", alignItems: "center" } : {}}
          >
            <div
              style={{
                display: "flex",
                fontSize: "13px",
                fontWeight: "bold",
                ...(props.inline ? { flex: 2 } : {}),
              }}
            >
              <label>Password</label>
              {props.isRequire && <div style={{ color: "red" }}>*</div>}
            </div>
            <Input
              type="password"
              placeholder="Password"
              value={password}
              style={props.inline ? { flex: 4 } : {}}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Field>
          {props.children}
        </Form>
      }
    />
  );
});

ModAuthen.displayName = "ModAuthen";

export default React.memo(ModAuthen);
